
import { ImageLoader } from "@src/helpers/ImageLoader";
import ImageResolution from "@src/saunaparts/ImageResolution";
import { LayerImageRepository, Sauna } from "..";
import { ColorLayer } from "./ColorLayer";
import { LowerBenchLightLayer } from "./LowerBenchLightLayer";


export class BencBasseLayer //implements Layer
{
    sauna:Sauna;
    imageRepository:LayerImageRepository;
    context:CanvasRenderingContext2D
    constructor(sauna:Sauna,imageRepository:LayerImageRepository,context:CanvasRenderingContext2D)
    {
        this.sauna = sauna;
        this.imageRepository=imageRepository;
        this.context= context;
    }   
    Render(desiredResolution: ImageResolution): Promise<CanvasRenderingContext2D> {        
        let baseimagePath =this.imageRepository.getBenchBaseLayer(this.sauna.Model,this.sauna.benchProductLine,this.sauna.benchMaterial,desiredResolution);

        return new ColorLayer(baseimagePath, this.sauna.benchMaterial.color, this.context).Render(desiredResolution).then(() => {
            if (this.sauna.benchProductLine.useProfileLayer) {
                let profileImagePath = this.imageRepository.getBenchProfileLayer(this.sauna.Model, this.sauna.benchProductLine, desiredResolution);
                return new ColorLayer(profileImagePath, this.sauna.profileMaterial.color, this.context).Render(desiredResolution);
            }
            else return this.context;
        }).then(() => {
                if (this.sauna.benchProductLine.usesMetalPartsLayer) 
                {
                    let metalPartsPartImageFile = this.imageRepository.getMetalPartsLayer(this.sauna.Model, this.sauna.benchProductLine, desiredResolution);
                    return new ImageLoader(metalPartsPartImageFile).Load().then(i => { this.context.drawImage(i, 0, 0, desiredResolution.width, desiredResolution.height); return this.context; } );
                }
                else
                    return this.context;    
        }).then(() => {
            let shadowImageFile = this.imageRepository.getBenchShadowImageLayer(this.sauna.Model,this.sauna.benchProductLine,this.sauna.benchMaterial,desiredResolution);
            return new ImageLoader(shadowImageFile).Load();
        }).then((sh)=>{
          this.context?.drawImage(sh,0,0,desiredResolution.width,desiredResolution.height);
          return new LowerBenchLightLayer(this.imageRepository,this.sauna).Render(desiredResolution,this.context);  
        }).then(()=>{
            return this.context;  
        });
    }
}